import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({
  children,
  delay = 0,
  y = 32,
  className = "",
}) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({
  lines,
  immediate = false,
  delay = 0,
  stagger = 0.12,
  className = "",
  lineClassName = "",
}) => (
  <span className={className}>
    {lines.map((line, i) => (
      <motion.span
        key={i}
        className="block overflow-hidden pb-[0.1em] -mb-[0.1em]"
        initial="hidden"
        {...(immediate
          ? { animate: "visible" }
          : { whileInView: "visible", viewport: { once: true, margin: "-40px" } })}
      >
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          variants={{
            hidden: { y: "115%" },
            visible: {
              y: 0,
              transition: {
                duration: 1.1,
                delay: delay + i * stagger,
                ease: EASE,
              },
            },
          }}
        >
          {line}
        </motion.span>
      </motion.span>
    ))}
  </span>
);

export const Sparkle = ({ className = "h-4 w-4 text-champagne" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M12 0c.9 6.6 5.4 11.1 12 12-6.6.9-11.1 5.4-12 12-.9-6.6-5.4-11.1-12-12C6.6 11.1 11.1 6.6 12 0z" />
  </svg>
);

export const Marquee = ({ items, dark = false, className = "" }) => {
  const half = [...items, ...items, ...items];
  return (
    <div
      className={`overflow-hidden border-y py-6 md:py-8 ${
        dark
          ? "border-white/10 bg-ink text-ivory"
          : "border-line bg-ivory text-ink"
      } ${className}`}
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center">
            {half.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className="whitespace-nowrap font-display text-3xl font-medium tracking-wide md:text-5xl">
                  {t}
                </span>
                <Sparkle className="mx-8 h-5 w-5 text-champagne md:mx-12 md:h-6 md:w-6" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
